import { gql } from "@apollo/client";

import calibrationNodeFragment from "./calibration-node-fragment";

export default gql`
  ${calibrationNodeFragment}
  mutation updateAssessmentAnswer(
    $complianceProgramId: Int!
    $templateId: Int!
    $questionId: Int!
    $targetId: Int!
    $answerId: Int
    $integerAnswer: Int
    $comment: String!
    $isSuggestion: Boolean!
    $isPrecalibration: Boolean!
  ) {
    createAssessmentAnswerCalibration(
      complianceProgramId: $complianceProgramId
      templateId: $templateId
      questionId: $questionId
      targetId: $targetId
      answerId: $answerId
      integerAnswer: $integerAnswer
      comment: $comment
      isSuggestion: $isSuggestion
      isPrecalibration: $isPrecalibration
    ) {
      answer {
        id
        ... on RangeAssessmentAnswerNode {
          hasCalibrations
          hasCalibrationSuggestions
          comment
          integerAnswer
        }
        ... on TalentIndicatorAssessmentAnswerNode {
          hasCalibrations
          hasCalibrationSuggestions
          comment
          integerAnswer
        }
      }
      answerCalibration {
        ...CalibrationNode
      }
    }
  }
`;
